import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { authAPI, UserContext } from '@mirinae/react-auth';

import withRouter from '@mirinae/utils/withRouter';
import UserAuthComponent from '@mirinae/explorer/components/userauth/UserAuthComponent';
import LoginLayerContainer from '@mirinae/explorer/containers/userauth/LoginLayerContainer';
import { authPaths, explorerPaths, navigateExternal } from '@mirinae/shared/defines/paths';
import SignUpLayerContainer from '@mirinae/explorer/containers/userauth/SignUpLayerContainer';
// import GTM from '@mirinae/shared/apis/GoogleAnalytics';

const SignUpContainer = props => {
    const [userContext] = useContext(UserContext);
    const isSignupTheme = props.theme === 'signup';
    // sign-up steps
    const [signupStep, setSingupStep] = useState(0);
    const [loginStep, setLoginStep] = useState(0);

    const navigate = useNavigate();

    authAPI.setHistory(window.history);
    const user = userContext.user;

    const handleBack = () => {
        // each time user clicks on the back button, it takes them back to one step before. when the step is 0, it takes them back to the previous page they came from.
        switch (signupStep) {
        case 0: navigate(-1); break;
        case 1:
        case 2:
        case 3: {
            setSingupStep(signupStep - 1);
            break;
        }
        default: throw new Error();
        }
    };

    useEffect(() => {
        if (user && typeof user.role === 'string' && user.role !== 'guest') {
            // console.log('SignupContainer redirect to /explorer');
            // console.log(window.location.href);

            // if we come here already signed-up, either after login/signup due to the user context update from the login/signup,
            // or because the signup/login was called inappropriately,
            // ensure we go to any requested redirect, essentially short-cutting any signup interaction
            const pathname = window.location.pathname;
            if (pathname.startsWith(authPaths.signup) || pathname.startsWith(authPaths.login)) {
                const qparams = new URLSearchParams(window.location.search);
                const redirect = qparams.get('redirect');
                navigateExternal(redirect || explorerPaths.home, { replace: true });
            }
        }
    }, [user]);

    return user && user.role === 'guest' ? (
        <UserAuthComponent className={isSignupTheme ? null : 'large'} onClick={handleBack} theme={props.theme}>
            {isSignupTheme
                ? (
                    <SignUpLayerContainer
                        {...props}
                        user={user}
                        step={signupStep}
                        setStep={setSingupStep}
                    />
                ) : (
                    <LoginLayerContainer
                        {...props}
                        user={user}
                        step={loginStep}
                        setStep={setLoginStep}
                    />
                )}
        </UserAuthComponent>
    ) : null;
};

export default withRouter(SignUpContainer);
